import { notification } from 'antd'

notification.config({
  duration: 0,
  placement: 'bottomLeft',
})

export const notificationWithoutTime = (type, description) => {
  notification[type]({
    message: type.charAt(0).toUpperCase() + type.substring(1),
    description,
    duration: 0,
  })
}
